<template>

    <div>

        FAQs

        <ul v-if="session">
            <li v-for="policy in session.driverProfile.quotePolicies">
                <span>{{ policy.quotePolicyID }}</span>
                <span>{{ policy.policyName }}</span>
                <span>{{ policy.version }}</span>
                <span>{{ policy.accepted }}</span>
                <span>{{ policy.acceptedDateTime }}</span>
            </li>
        </ul>

    </div>

</template>

<script>
    export default {
        props: ['session']
    }
</script>
